/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginWithEmailAndPasswordChallengeResponse
 */
export interface LoginWithEmailAndPasswordChallengeResponse {
    /**
     * 
     * @type {string}
     * @memberof LoginWithEmailAndPasswordChallengeResponse
     */
    authFlow: LoginWithEmailAndPasswordChallengeResponseAuthFlowEnum;
    /**
     * 
     * @type {string}
     * @memberof LoginWithEmailAndPasswordChallengeResponse
     */
    challengeName: string;
    /**
     * 
     * @type {string}
     * @memberof LoginWithEmailAndPasswordChallengeResponse
     */
    session: string;
}


/**
 * @export
 */
export const LoginWithEmailAndPasswordChallengeResponseAuthFlowEnum = {
    Challenge: 'CHALLENGE'
} as const;
export type LoginWithEmailAndPasswordChallengeResponseAuthFlowEnum = typeof LoginWithEmailAndPasswordChallengeResponseAuthFlowEnum[keyof typeof LoginWithEmailAndPasswordChallengeResponseAuthFlowEnum];


/**
 * Check if a given object implements the LoginWithEmailAndPasswordChallengeResponse interface.
 */
export function instanceOfLoginWithEmailAndPasswordChallengeResponse(value: object): value is LoginWithEmailAndPasswordChallengeResponse {
    if (!('authFlow' in value) || value['authFlow'] === undefined) return false;
    if (!('challengeName' in value) || value['challengeName'] === undefined) return false;
    if (!('session' in value) || value['session'] === undefined) return false;
    return true;
}

export function LoginWithEmailAndPasswordChallengeResponseFromJSON(json: any): LoginWithEmailAndPasswordChallengeResponse {
    return LoginWithEmailAndPasswordChallengeResponseFromJSONTyped(json, false);
}

export function LoginWithEmailAndPasswordChallengeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginWithEmailAndPasswordChallengeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'authFlow': json['authFlow'],
        'challengeName': json['challengeName'],
        'session': json['session'],
    };
}

export function LoginWithEmailAndPasswordChallengeResponseToJSON(json: any): LoginWithEmailAndPasswordChallengeResponse {
    return LoginWithEmailAndPasswordChallengeResponseToJSONTyped(json, false);
}

export function LoginWithEmailAndPasswordChallengeResponseToJSONTyped(value?: LoginWithEmailAndPasswordChallengeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'authFlow': value['authFlow'],
        'challengeName': value['challengeName'],
        'session': value['session'],
    };
}

